import WaveSurfer from "wavesurfer.js";

export async function decodeAudioPeaks(
  file: File,
): Promise<{ peaks: number[][]; durationMs: number }> {
  const url = URL.createObjectURL(file);

  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.left = "-9999px";
  container.style.width = "1px";
  container.style.height = "1px";
  document.body.appendChild(container);

  const wavesurfer = WaveSurfer.create({ container, url, height: 1 });

  try {
    await new Promise<void>((resolve, reject) => {
      wavesurfer.on("ready", () => resolve());
      wavesurfer.on("error", (error) => reject(error));
    });

    const peaks = wavesurfer.exportPeaks({
      channels: 2,
      maxLength: 8000,
      precision: 10000,
    });
    const durationMs = Math.round(wavesurfer.getDuration() * 1000);

    return { peaks, durationMs };
  } finally {
    wavesurfer.destroy();
    container.remove();
    URL.revokeObjectURL(url);
  }
}
